/**
 * Created by mukund on 2/18/16.
 */

'use strict';

angular.module('mediacloudApp')
    .config(function ($stateProvider) {
        $stateProvider
            .state('lmsPlayback', {
                parent: 'site',
                url: '/lms/playback/:collectionType/:collectionId/:assetId',
                params: {
                    rootCollectionId: null
                },
                data: {
                    roles: [],
                    pageTitle: 'playback.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'scripts/app/playback/templates/playback.html',
                        controller: 'PlaybackController'
                    }
                },

                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('playback');
                        return $translate.refresh();
                    }]
                }
            });
    });
